import { Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output, inject } from '@angular/core';

@Directive({
  selector: '[inViewport]',
  standalone: true,
})
export class InViewportDirective implements OnInit, OnDestroy {
  private element = inject(ElementRef);

  private observer: IntersectionObserver;
  @Output() public readonly visible = new EventEmitter<boolean>();

  public ngOnInit(): void {
    if (this.element) {
      this.registerObserver();
    }
  }

  public ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  private registerObserver(): void {
    this.observer = new IntersectionObserver((entries) => {
      this.visible.emit(entries[entries.length - 1].isIntersecting);
    });

    this.observer.observe(this.element.nativeElement);
  }
}
